const faqData = [
  {
    q: '黑料吃瓜有哪些访问版本？',
    a: '目前提供51黑料吃瓜、91黑料吃瓜、17黑料吃瓜等多个数字版专属入口，同时还有黑料吃瓜52、黑料吃瓜92、黑料吃瓜18等备用线路。所有版本内容同步更新，用户可根据网络情况选择最快的线路访问。',
  },
  {
    q: '不同数字版本有什么区别？',
    a: '各版本的核心内容完全一致，区别在于服务器部署位置和线路优化策略。51版、91版和17版为主力线路，覆盖不同网络运营商；52版、92版和18版为辅助线路，在主线路拥挤时提供备选访问通道。',
  },
  {
    q: '如何使用线路选择功能？',
    a: '访问本站首页即可看到所有可用线路入口，点击任意版本编号直接跳转。建议将本站加入浏览器收藏夹，每次通过本站选择最优线路访问，避免因域名变更而找不到最新入口。',
  },
  {
    q: '站内内容是否免费浏览？',
    a: '是的，所有爆料内容、榜单、话题和专题均完全免费开放浏览，无需注册或付费。我们致力于为用户提供便捷、无障碍的资讯获取体验。',
  },
  {
    q: '如何投稿爆料内容？',
    a: '可通过本站"联系我们"区域的投稿通道提交爆料线索。请提供尽可能详细的事件描述和可验证的证据材料，编辑团队审核通过后会及时跟进并发布。投稿者身份信息严格保密。',
  },
  {
    q: '移动端如何获得最佳体验？',
    a: '黑料吃瓜全平台采用响应式设计，通过手机浏览器直接访问即可获得与桌面端一致的功能体验，无需下载任何APP。建议使用Chrome或Safari等主流浏览器访问。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">常见问答</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">关于黑料吃瓜的使用说明与常见问题解答</p>

        <div className="max-w-3xl space-y-3">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-8">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}